export default "__VITE_ASSET__bfd405cc__"